import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';

/**
 * The application's busy indicator, shown for work the user is waiting on.
 *
 * <p>{@link LoaderService} already existed and counted requests, but nothing ever rendered its
 * state - so calling showLoader() did nothing visible, and an action like approving a customer
 * looked as though the click had been ignored while the request was in flight.
 *
 * <p>Rendered once at the application root. Any component can raise it through the service; the
 * counter means two overlapping requests still leave one overlay, and it clears when the last of
 * them finishes.
 *
 * <p>For a page's own first load, prefer the inline skeleton or app-loading-state - a full-screen
 * overlay is for a deliberate action, not for arriving somewhere.
 */
@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.scss',
})
export class GlobalLoaderComponent {
  constructor(protected loader: LoaderService) {}
}
